import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeRequestForQuotationCreate,
  detail: routeRequestForQuotationDetail,
  home: routeRequestForQuotationsHome,
  root: routeRequestForQuotationsRoot,
} = createDoctypeRoutes({
  createName: 'new-request-for-quotation',
  createPath: 'new-request-for-quotation',
  detailName: 'request-for-quotation-detail',
  doctype: DOCTYPES.REQUEST_FOR_QUOTATION,
  homeName: 'request-for-quotations-home',
  ifOwner: false,
  path: 'request-for-quotations',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/requestForQuotation/AddRequestForQuotation.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/requestForQuotation/ViewRequestForQuotation.vue'),
    list: async () =>
      await import('@/components/viewsExternal/requestForQuotation/RequestForQuotationView.vue'),
  },
})

export {
  routeRequestForQuotationCreate,
  routeRequestForQuotationDetail,
  routeRequestForQuotationsHome,
  routeRequestForQuotationsRoot,
}
